import { CloseIcon } from 'components/atoms/icons'

export const IconClose = ({ children, onClick }) => {
	return (
		<div className='container-search'>
			<button className='container-search__close-icon-absolute' onClick={onClick}>
				<CloseIcon color='#FF3386' width='1.7rem' height='1.7rem' />
				{children}
			</button>
		</div>
	)
}
